/**
 * usePageTitle — set the browser tab title for this route.
 *
 * Usage in a page component:
 *
 *   usePageTitle('Tasty Tracks');
 *
 * Produces the title "Tasty Tracks · NachoFiles". Pass an empty string or
 * no argument on pages that should just show "NachoFiles" (e.g. home).
 */

import { useEffect } from 'react';

const SITE_NAME = 'NachoFiles';

export function usePageTitle(pageTitle) {
  useEffect(() => {
    const previous = document.title;

    if (pageTitle && pageTitle.trim()) {
      document.title = `${pageTitle.trim()} · ${SITE_NAME}`;
    } else {
      document.title = SITE_NAME;
    }

    // Restore the previous title when this component unmounts — avoids
    // the title sticking after navigation if the next page forgets to set one.
    return () => { document.title = previous; };
  }, [pageTitle]);
}
